// Complete list of allowed countries (excluding restricted territories)
// Restricted: Abkhazia, Afghanistan, Azores, Bahamas, Benin, Belarus, Cameroon, Central African Republic, Chad, Congo (Democratic Republic), 
// Cote d'Ivoire, Crimea, Cuba, Donetsk National Republic (DNR), Eritrea, Gaza Strip, Ghana, Guinea, Guinea-Bissau, Haiti, Iran, Iraq, 
// Kashmir, Kherson, Korea (Democratic People's Republic), Kosovo, Kuwait, Lebanon, Liberia, Libya, Luhansk National Republic (LNR), Mali, 
// Myanmar, Nagorno Karabakh, Northern Cyprus, Nicaragua, Pakistan, Palestine, Panama, Qatar, Russian Federation, Somalia, South Ossetia, 
// South Sudan, Sudan, Syrian Arab Republic, Togo, Trinidad and Tobago, Uganda, Venezuela, Yemen, Zaporizhzhia, Zimbabwe, West Bank

export const allCountries = [
    {
        name: 'Albania',
        flag: '🇦🇱',
        code: '+355',
        iso: 'AL',
        mask: '(###)###-###'
    },
    {
        name: 'Algeria',
        flag: '🇩🇿',
        code: '+213',
        iso: 'DZ',
        mask: '##-###-####'
    },
    {
        name: 'American Samoa',
        flag: '🇦🇸',
        code: '+1684',
        iso: 'AS',
        mask: '(###)###-####'
    },
    {
        name: 'Andorra',
        flag: '🇦🇩',
        code: '+376',
        iso: 'AD',
        mask: '###-###'
    },
    {
        name: 'Angola',
        flag: '🇦🇴',
        code: '+244',
        iso: 'AO',
        mask: '(###)###-###'
    },
    {
        name: 'Anguilla',
        flag: '🇦🇮',
        code: '+1264',
        iso: 'AI',
        mask: '(###)###-####'
    },
    {
        name: 'Antarctica',
        flag: '🇦🇶',
        code: '+672',
        iso: 'AQ',
        mask: '###-###'
    },
    {
        name: 'Antigua and Barbuda',
        flag: '🇦🇬',
        code: '+1268',
        iso: 'AG',
        mask: '(###)###-####'
    },
    {
        name: 'Argentina',
        flag: '🇦🇷',
        code: '+54',
        iso: 'AR',
        mask: '(###)###-####'
    },
    {
        name: 'Armenia',
        flag: '🇦🇲',
        code: '+374',
        iso: 'AM',
        mask: '##-###-###'
    },
    {
        name: 'Aruba',
        flag: '🇦🇼',
        code: '+297',
        iso: 'AW',
        mask: '###-####'
    },
    {
        name: 'Australia',
        flag: '🇦🇺',
        code: '+61',
        iso: 'AU',
        mask: '#-####-####'
    },
    {
        name: 'Austria',
        flag: '🇦🇹',
        code: '+43',
        iso: 'AT',
        mask: '(###)###-####'
    },
    {
        name: 'Azerbaijan',
        flag: '🇦🇿',
        code: '+994',
        iso: 'AZ',
        mask: '##-###-##-##'
    },
    {
        name: 'Barbados',
        flag: '🇧🇧',
        code: '+1246',
        iso: 'BB',
        mask: '(###)###-####'
    },
    {
        name: 'Bangladesh',
        flag: '🇧🇩',
        code: '+880',
        iso: 'BD',
        mask: '##-###-###'
    },
    {
        name: 'Belgium',
        flag: '🇧🇪',
        code: '+32',
        iso: 'BE',
        mask: '(###)###-###'
    },
    {
        name: 'Belize',
        flag: '🇧🇿',
        code: '+501',
        iso: 'BZ',
        mask: '###-####'
    },
    {
        name: 'Bermuda',
        flag: '🇧🇲',
        code: '+1441',
        iso: 'BM',
        mask: '(###)###-####'
    },
    {
        name: 'Bhutan',
        flag: '🇧🇹',
        code: '+975',
        iso: 'BT',
        mask: '#-###-###'
    },
    {
        name: 'Bolivia',
        flag: '🇧🇴',
        code: '+591',
        iso: 'BO',
        mask: '#-###-####'
    },
    {
        name: 'Bosnia and Herzegovina',
        flag: '🇧🇦',
        code: '+387',
        iso: 'BA',
        mask: '##-###-###'
    },
    {
        name: 'Botswana',
        flag: '🇧🇼',
        code: '+267',
        iso: 'BW',
        mask: '##-###-###'
    },
    {
        name: 'Brazil',
        flag: '🇧🇷',
        code: '+55',
        iso: 'BR',
        mask: '(##)####-####'
    },
    {
        name: 'British Virgin Islands',
        flag: '🇻🇬',
        code: '+1284',
        iso: 'VG',
        mask: '(###)###-####'
    },
    {
        name: 'Brunei',
        flag: '🇧🇳',
        code: '+673',
        iso: 'BN',
        mask: '###-####'
    },
    {
        name: 'Bulgaria',
        flag: '🇧🇬',
        code: '+359',
        iso: 'BG',
        mask: '(###)###-###'
    },
    {
        name: 'Burkina Faso',
        flag: '🇧🇫',
        code: '+226',
        iso: 'BF',
        mask: '##-##-####'
    },
    {
        name: 'Burundi',
        flag: '🇧🇮',
        code: '+257',
        iso: 'BI',
        mask: '##-##-####'
    },
    {
        name: 'Cambodia',
        flag: '🇰🇭',
        code: '+855',
        iso: 'KH',
        mask: '##-###-###'
    },
    {
        name: 'Canada',
        flag: '🇨🇦',
        code: '+1',
        iso: 'CA',
        mask: '(###)###-####'
    },
    {
        name: 'Cape Verde',
        flag: '🇨🇻',
        code: '+238',
        iso: 'CV',
        mask: '(###)##-##'
    },
    {
        name: 'Cayman Islands',
        flag: '🇰🇾',
        code: '+1345',
        iso: 'KY',
        mask: '(###)###-####'
    },
    {
        name: 'Chile',
        flag: '🇨🇱',
        code: '+56',
        iso: 'CL',
        mask: '#-####-####'
    },
    {
        name: 'China',
        flag: '🇨🇳',
        code: '+86',
        iso: 'CN',
        mask: '(###)####-####'
    },
    {
        name: 'Christmas Island',
        flag: '🇨🇽',
        code: '+61',
        iso: 'CX',
        mask: '#-####-####'
    },
    {
        name: 'Cocos Islands',
        flag: '🇨🇨',
        code: '+61',
        iso: 'CC',
        mask: '#-####-####'
    },
    {
        name: 'Colombia',
        flag: '🇨🇴',
        code: '+57',
        iso: 'CO',
        mask: '(###)###-####'
    },
    {
        name: 'Comoros',
        flag: '🇰🇲',
        code: '+269',
        iso: 'KM',
        mask: '##-##-###'
    },
    {
        name: 'Congo',
        flag: '🇨🇬',
        code: '+242',
        iso: 'CG',
        mask: '##-###-####'
    },
    {
        name: 'Cook Islands',
        flag: '🇨🇰',
        code: '+682',
        iso: 'CK',
        mask: '##-###'
    },
    {
        name: 'Costa Rica',
        flag: '🇨🇷',
        code: '+506',
        iso: 'CR',
        mask: '####-####'
    },
    {
        name: 'Croatia',
        flag: '🇭🇷',
        code: '+385',
        iso: 'HR',
        mask: '##-###-###'
    },
    {
        name: 'Cyprus',
        flag: '🇨🇾',
        code: '+357',
        iso: 'CY',
        mask: '##-###-###'
    },
    {
        name: 'Czech Republic',
        flag: '🇨🇿',
        code: '+420',
        iso: 'CZ',
        mask: '(###)###-###'
    },
    {
        name: 'Denmark',
        flag: '🇩🇰',
        code: '+45',
        iso: 'DK',
        mask: '##-##-##-##'
    },
    {
        name: 'Djibouti',
        flag: '🇩🇯',
        code: '+253',
        iso: 'DJ',
        mask: '##-##-##-##'
    },
    {
        name: 'Dominica',
        flag: '🇩🇲',
        code: '+1767',
        iso: 'DM',
        mask: '(###)###-####'
    },
    {
        name: 'Dominican Republic',
        flag: '🇩🇴',
        code: '+1809',
        iso: 'DO',
        mask: '(###)###-####'
    },
    {
        name: 'East Timor',
        flag: '🇹🇱',
        code: '+670',
        iso: 'TL',
        mask: '###-####'
    },
    {
        name: 'Ecuador',
        flag: '🇪🇨',
        code: '+593',
        iso: 'EC',
        mask: '##-###-####'
    },
    {
        name: 'Egypt',
        flag: '🇪🇬',
        code: '+20',
        iso: 'EG',
        mask: '(###)###-####'
    },
    {
        name: 'El Salvador',
        flag: '🇸🇻',
        code: '+503',
        iso: 'SV',
        mask: '##-##-####'
    },
    {
        name: 'Equatorial Guinea',
        flag: '🇬🇶',
        code: '+240',
        iso: 'GQ',
        mask: '##-###-####'
    },
    {
        name: 'Estonia',
        flag: '🇪🇪',
        code: '+372',
        iso: 'EE',
        mask: '####-####'
    },
    {
        name: 'Ethiopia',
        flag: '🇪🇹',
        code: '+251',
        iso: 'ET',
        mask: '##-###-####'
    },
    {
        name: 'Falkland Islands',
        flag: '🇫🇰',
        code: '+500',
        iso: 'FK',
        mask: '#####'
    },
    {
        name: 'Faroe Islands',
        flag: '🇫🇴',
        code: '+298',
        iso: 'FO',
        mask: '######'
    },
    {
        name: 'Fiji',
        flag: '🇫🇯',
        code: '+679',
        iso: 'FJ',
        mask: '##-#####'
    },
    {
        name: 'Finland',
        flag: '🇫🇮',
        code: '+358',
        iso: 'FI',
        mask: '(###)###-##-##'
    },
    {
        name: 'France',
        flag: '🇫🇷',
        code: '+33',
        iso: 'FR',
        mask: '(###)###-####'
    },
    {
        name: 'French Guiana',
        flag: '🇬🇫',
        code: '+594',
        iso: 'GF',
        mask: '#####-####'
    },
    {
        name: 'French Polynesia',
        flag: '🇵🇫',
        code: '+689',
        iso: 'PF',
        mask: '##-##-##'
    },
    {
        name: 'Gabon',
        flag: '🇬🇦',
        code: '+241',
        iso: 'GA',
        mask: '#-##-##-##'
    },
    {
        name: 'Gambia',
        flag: '🇬🇲',
        code: '+220',
        iso: 'GM',
        mask: '(###)####'
    },
    {
        name: 'Georgia',
        flag: '🇬🇪',
        code: '+995',
        iso: 'GE',
        mask: '(###)###-###'
    },
    {
        name: 'Germany',
        flag: '🇩🇪',
        code: '+49',
        iso: 'DE',
        mask: '(####)###-####'
    },
    {
        name: 'Gibraltar',
        flag: '🇬🇮',
        code: '+350',
        iso: 'GI',
        mask: '###-#####'
    },
    {
        name: 'Greece',
        flag: '🇬🇷',
        code: '+30',
        iso: 'GR',
        mask: '(###)###-####'
    },
    {
        name: 'Greenland',
        flag: '🇬🇱',
        code: '+299',
        iso: 'GL',
        mask: '##-##-##'
    },
    {
        name: 'Grenada',
        flag: '🇬🇩',
        code: '+1473',
        iso: 'GD',
        mask: '(###)###-####'
    },
    {
        name: 'Guadeloupe',
        flag: '🇬🇵',
        code: '+590',
        iso: 'GP',
        mask: '(###)###-###'
    },
    {
        name: 'Guam',
        flag: '🇬🇺',
        code: '+1671',
        iso: 'GU',
        mask: '(###)###-####'
    },
    {
        name: 'Guatemala',
        flag: '🇬🇹',
        code: '+502',
        iso: 'GT',
        mask: '#-###-####'
    },
    {
        name: 'Guernsey',
        flag: '🇬🇬',
        code: '+44',
        iso: 'GG',
        mask: '##-####-####'
    },
    {
        name: 'Guyana',
        flag: '🇬🇾',
        code: '+592',
        iso: 'GY',
        mask: '###-####'
    },
    {
        name: 'Honduras',
        flag: '🇭🇳',
        code: '+504',
        iso: 'HN',
        mask: '####-####'
    },
    {
        name: 'Hong Kong',
        flag: '🇭🇰',
        code: '+852',
        iso: 'HK',
        mask: '####-####'
    },
    {
        name: 'Hungary',
        flag: '🇭🇺',
        code: '+36',
        iso: 'HU',
        mask: '(###)###-###'
    },
    {
        name: 'Iceland',
        flag: '🇮🇸',
        code: '+354',
        iso: 'IS',
        mask: '###-####'
    },
    {
        name: 'India',
        flag: '🇮🇳',
        code: '+91',
        iso: 'IN',
        mask: '(####)###-###'
    },
    {
        name: 'Indonesia',
        flag: '🇮🇩',
        code: '+62',
        iso: 'ID',
        mask: '##-###-####'
    },
    {
        name: 'Ireland',
        flag: '🇮🇪',
        code: '+353',
        iso: 'IE',
        mask: '(###)###-####'
    },
    {
        name: 'Isle of Man',
        flag: '🇮🇲',
        code: '+44',
        iso: 'IM',
        mask: '##-####-####'
    },
    {
        name: 'Israel',
        flag: '🇮🇱',
        code: '+972',
        iso: 'IL',
        mask: '#-###-####'
    },
    {
        name: 'Italy',
        flag: '🇮🇹',
        code: '+39',
        iso: 'IT',
        mask: '(###)####-####'
    },
    {
        name: 'Jamaica',
        flag: '🇯🇲',
        code: '+1876',
        iso: 'JM',
        mask: '(###)###-####'
    },
    {
        name: 'Japan',
        flag: '🇯🇵',
        code: '+81',
        iso: 'JP',
        mask: '(###)###-####'
    },
    {
        name: 'Jersey',
        flag: '🇯🇪',
        code: '+44',
        iso: 'JE',
        mask: '##-####-####'
    },
    {
        name: 'Jordan',
        flag: '🇯🇴',
        code: '+962',
        iso: 'JO',
        mask: '#-####-####'
    },
    {
        name: 'Kazakhstan',
        flag: '🇰🇿',
        code: '+7',
        iso: 'KZ',
        mask: '(###)###-##-##'
    },
    {
        name: 'Kenya',
        flag: '🇰🇪',
        code: '+254',
        iso: 'KE',
        mask: '##-#######'
    },
    {
        name: 'Kiribati',
        flag: '🇰🇮',
        code: '+686',
        iso: 'KI',
        mask: '##-###'
    },
    {
        name: 'South Korea',
        flag: '🇰🇷',
        code: '+82',
        iso: 'KR',
        mask: '##-####-####'
    },
    {
        name: 'Kyrgyzstan',
        flag: '🇰🇬',
        code: '+996',
        iso: 'KG',
        mask: '(###)###-###'
    },
    {
        name: 'Laos',
        flag: '🇱🇦',
        code: '+856',
        iso: 'LA',
        mask: '##-###-###'
    },
    {
        name: 'Latvia',
        flag: '🇱🇻',
        code: '+371',
        iso: 'LV',
        mask: '##-###-###'
    },
    {
        name: 'Lesotho',
        flag: '🇱🇸',
        code: '+266',
        iso: 'LS',
        mask: '#-###-####'
    },
    {
        name: 'Liechtenstein',
        flag: '🇱🇮',
        code: '+423',
        iso: 'LI',
        mask: '(###)###-####'
    },
    {
        name: 'Lithuania',
        flag: '🇱🇹',
        code: '+370',
        iso: 'LT',
        mask: '(###)##-###'
    },
    {
        name: 'Luxembourg',
        flag: '🇱🇺',
        code: '+352',
        iso: 'LU',
        mask: '(###)###-###'
    },
    {
        name: 'Macau',
        flag: '🇲🇴',
        code: '+853',
        iso: 'MO',
        mask: '####-####'
    },
    {
        name: 'Macedonia',
        flag: '🇲🇰',
        code: '+389',
        iso: 'MK',
        mask: '##-###-###'
    },
    {
        name: 'Madagascar',
        flag: '🇲🇬',
        code: '+261',
        iso: 'MG',
        mask: '##-##-#####'
    },
    {
        name: 'Malawi',
        flag: '🇲🇼',
        code: '+265',
        iso: 'MW',
        mask: '#-####-####'
    },
    {
        name: 'Malaysia',
        flag: '🇲🇾',
        code: '+60',
        iso: 'MY',
        mask: '##-####-####'
    },
    {
        name: 'Maldives',
        flag: '🇲🇻',
        code: '+960',
        iso: 'MV',
        mask: '###-####'
    },
    {
        name: 'Malta',
        flag: '🇲🇹',
        code: '+356',
        iso: 'MT',
        mask: '####-####'
    },
    {
        name: 'Marshall Islands',
        flag: '🇲🇭',
        code: '+692',
        iso: 'MH',
        mask: '###-####'
    },
    {
        name: 'Martinique',
        flag: '🇲🇶',
        code: '+596',
        iso: 'MQ',
        mask: '(###)##-##-##'
    },
    {
        name: 'Mauritania',
        flag: '🇲🇷',
        code: '+222',
        iso: 'MR',
        mask: '##-##-####'
    },
    {
        name: 'Mauritius',
        flag: '🇲🇺',
        code: '+230',
        iso: 'MU',
        mask: '####-####'
    },
    {
        name: 'Mayotte',
        flag: '🇾🇹',
        code: '+262',
        iso: 'YT',
        mask: '#####-####'
    },
    {
        name: 'Mexico',
        flag: '🇲🇽',
        code: '+52',
        iso: 'MX',
        mask: '(###)###-####'
    },
    {
        name: 'Micronesia',
        flag: '🇫🇲',
        code: '+691',
        iso: 'FM',
        mask: '###-####'
    },
    {
        name: 'Moldova',
        flag: '🇲🇩',
        code: '+373',
        iso: 'MD',
        mask: '####-####'
    },
    {
        name: 'Monaco',
        flag: '🇲🇨',
        code: '+377',
        iso: 'MC',
        mask: '##-###-###'
    },
    {
        name: 'Mongolia',
        flag: '🇲🇳',
        code: '+976',
        iso: 'MN',
        mask: '##-##-####'
    },
    {
        name: 'Montenegro',
        flag: '🇲🇪',
        code: '+382',
        iso: 'ME',
        mask: '##-###-###'
    },
    {
        name: 'Montserrat',
        flag: '🇲🇸',
        code: '+1664',
        iso: 'MS',
        mask: '(###)###-####'
    },
    {
        name: 'Morocco',
        flag: '🇲🇦',
        code: '+212',
        iso: 'MA',
        mask: '##-####-###'
    },
    {
        name: 'Mozambique',
        flag: '🇲🇿',
        code: '+258',
        iso: 'MZ',
        mask: '##-###-###'
    },
    {
        name: 'Namibia',
        flag: '🇳🇦',
        code: '+264',
        iso: 'NA',
        mask: '##-###-####'
    },
    {
        name: 'Nauru',
        flag: '🇳🇷',
        code: '+674',
        iso: 'NR',
        mask: '###-####'
    },
    {
        name: 'Nepal',
        flag: '🇳🇵',
        code: '+977',
        iso: 'NP',
        mask: '##-###-###'
    },
    {
        name: 'Netherlands',
        flag: '🇳🇱',
        code: '+31',
        iso: 'NL',
        mask: '##-###-####'
    },
    {
        name: 'Netherlands Antilles',
        flag: '🇧🇶',
        code: '+599',
        iso: 'BQ',
        mask: '###-####'
    },
    {
        name: 'New Caledonia',
        flag: '🇳🇨',
        code: '+687',
        iso: 'NC',
        mask: '##-####'
    },
    {
        name: 'New Zealand',
        flag: '🇳🇿',
        code: '+64',
        iso: 'NZ',
        mask: '(###)###-###'
    },
    {
        name: 'Niger',
        flag: '🇳🇪',
        code: '+227',
        iso: 'NE',
        mask: '##-##-####'
    },
    {
        name: 'Nigeria',
        flag: '🇳🇬',
        code: '+234',
        iso: 'NG',
        mask: '##-###-###'
    },
    {
        name: 'Niue',
        flag: '🇳🇺',
        code: '+683',
        iso: 'NU',
        mask: '####'
    },
    {
        name: 'Norfolk Island',
        flag: '🇳🇫',
        code: '+672',
        iso: 'NF',
        mask: '##-####'
    },
    {
        name: 'Northern Mariana Islands',
        flag: '🇲🇵',
        code: '+1670',
        iso: 'MP',
        mask: '(###)###-####'
    },
    {
        name: 'Norway',
        flag: '🇳🇴',
        code: '+47',
        iso: 'NO',
        mask: '(###)##-###'
    },
    {
        name: 'Oman',
        flag: '🇴🇲',
        code: '+968',
        iso: 'OM',
        mask: '##-###-###'
    },
    {
        name: 'Palau',
        flag: '🇵🇼',
        code: '+680',
        iso: 'PW',
        mask: '###-####'
    },
    {
        name: 'Papua New Guinea',
        flag: '🇵🇬',
        code: '+675',
        iso: 'PG',
        mask: '(###)##-###'
    },
    {
        name: 'Paraguay',
        flag: '🇵🇾',
        code: '+595',
        iso: 'PY',
        mask: '(###)###-###'
    },
    {
        name: 'Peru',
        flag: '🇵🇪',
        code: '+51',
        iso: 'PE',
        mask: '(###)###-###'
    },
    {
        name: 'Philippines',
        flag: '🇵🇭',
        code: '+63',
        iso: 'PH',
        mask: '(###)###-####'
    },
    {
        name: 'Pitcairn Islands',
        flag: '🇵🇳',
        code: '+64',
        iso: 'PN',
        mask: '##-####'
    },
    {
        name: 'Poland',
        flag: '🇵🇱',
        code: '+48',
        iso: 'PL',
        mask: '(###)###-###'
    },
    {
        name: 'Portugal',
        flag: '🇵🇹',
        code: '+351',
        iso: 'PT',
        mask: '##-###-####'
    },
    {
        name: 'Puerto Rico',
        flag: '🇵🇷',
        code: '+1787',
        iso: 'PR',
        mask: '(###)###-####'
    },
    {
        name: 'Reunion',
        flag: '🇷🇪',
        code: '+262',
        iso: 'RE',
        mask: '#####-####'
    },
    {
        name: 'Romania',
        flag: '🇷🇴',
        code: '+40',
        iso: 'RO',
        mask: '##-###-####'
    },
    {
        name: 'Rwanda',
        flag: '🇷🇼',
        code: '+250',
        iso: 'RW',
        mask: '(###)###-###'
    },
    {
        name: "Russia",
        flag: '🇷🇺',
        code: "+7",
        iso: "RU",
        mask: "(###)###-##-##"
    },
    {
        name: 'Saint Helena',
        flag: '🇸🇭',
        code: '+290',
        iso: 'SH',
        mask: '####'
    },
    {
        name: 'Saint Kitts and Nevis',
        flag: '🇰🇳',
        code: '+1869',
        iso: 'KN',
        mask: '(###)###-####'
    },
    {
        name: 'Saint Lucia',
        flag: '🇱🇨',
        code: '+1758',
        iso: 'LC',
        mask: '(###)###-####'
    },
    {
        name: 'Saint Pierre and Miquelon',
        flag: '🇵🇲',
        code: '+508',
        iso: 'PM',
        mask: '##-####'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        flag: '🇻🇨',
        code: '+1784',
        iso: 'VC',
        mask: '(###)###-####'
    },
    {
        name: 'Samoa',
        flag: '🇼🇸',
        code: '+685',
        iso: 'WS',
        mask: '##-####'
    },
    {
        name: 'San Marino',
        flag: '🇸🇲',
        code: '+378',
        iso: 'SM',
        mask: '####-######'
    },
    {
        name: 'Sao Tome and Principe',
        flag: '🇸🇹',
        code: '+239',
        iso: 'ST',
        mask: '##-#####'
    },
    {
        name: 'Saudi Arabia',
        flag: '🇸🇦',
        code: '+966',
        iso: 'SA',
        mask: '#-####-####'
    },
    {
        name: 'Senegal',
        flag: '🇸🇳',
        code: '+221',
        iso: 'SN',
        mask: '##-###-####'
    },
    {
        name: 'Serbia',
        flag: '🇷🇸',
        code: '+381',
        iso: 'RS',
        mask: '##-###-####'
    },
    {
        name: 'Seychelles',
        flag: '🇸🇨',
        code: '+248',
        iso: 'SC',
        mask: '#-###-###'
    },
    {
        name: 'Sierra Leone',
        flag: '🇸🇱',
        code: '+232',
        iso: 'SL',
        mask: '##-######'
    },
    {
        name: 'Singapore',
        flag: '🇸🇬',
        code: '+65',
        iso: 'SG',
        mask: '####-####'
    },
    {
        name: 'Slovakia',
        flag: '🇸🇰',
        code: '+421',
        iso: 'SK',
        mask: '(###)###-###'
    },
    {
        name: 'Slovenia',
        flag: '🇸🇮',
        code: '+386',
        iso: 'SI',
        mask: '##-###-###'
    },
    {
        name: 'Solomon Islands',
        flag: '🇸🇧',
        code: '+677',
        iso: 'SB',
        mask: '###-####'
    },
    {
        name: 'South Africa',
        flag: '🇿🇦',
        code: '+27',
        iso: 'ZA',
        mask: '##-###-####'
    },
    {
        name: 'South Georgia and the South Sandwich Islands',
        flag: '🇬🇸',
        code: '+500',
        iso: 'GS',
        mask: '#####'
    },
    {
        name: 'Spain',
        flag: '🇪🇸',
        code: '+34',
        iso: 'ES',
        mask: '(###)###-###'
    },
    {
        name: 'Sri Lanka',
        flag: '🇱🇰',
        code: '+94',
        iso: 'LK',
        mask: '##-###-####'
    },
    {
        name: 'Suriname',
        flag: '🇸🇷',
        code: '+597',
        iso: 'SR',
        mask: '###-####'
    },
    {
        name: 'Svalbard and Jan Mayen',
        flag: '🇸🇯',
        code: '+47',
        iso: 'SJ',
        mask: '(###)##-###'
    },
    {
        name: 'Swaziland',
        flag: '🇸🇿',
        code: '+268',
        iso: 'SZ',
        mask: '##-##-####'
    },
    {
        name: 'Sweden',
        flag: '🇸🇪',
        code: '+46',
        iso: 'SE',
        mask: '##-###-####'
    },
    {
        name: 'Switzerland',
        flag: '🇨🇭',
        code: '+41',
        iso: 'CH',
        mask: '##-###-####'
    },
    {
        name: 'Taiwan',
        flag: '🇹🇼',
        code: '+886',
        iso: 'TW',
        mask: '#-####-####'
    },
    {
        name: 'Tajikistan',
        flag: '🇹🇯',
        code: '+992',
        iso: 'TJ',
        mask: '##-###-####'
    },
    {
        name: 'Tanzania',
        flag: '🇹🇿',
        code: '+255',
        iso: 'TZ',
        mask: '##-###-####'
    },
    {
        name: 'Thailand',
        flag: '🇹🇭',
        code: '+66',
        iso: 'TH',
        mask: '##-###-####'
    },
    {
        name: 'Tonga',
        flag: '🇹🇴',
        code: '+676',
        iso: 'TO',
        mask: '#####'
    },
    {
        name: 'Tunisia',
        flag: '🇹🇳',
        code: '+216',
        iso: 'TN',
        mask: '##-###-###'
    },
    {
        name: 'Turkey',
        flag: '🇹🇷',
        code: '+90',
        iso: 'TR',
        mask: '(###)###-####'
    },
    {
        name: 'Turkmenistan',
        flag: '🇹🇲',
        code: '+993',
        iso: 'TM',
        mask: '#-###-####'
    },
    {
        name: 'Turks and Caicos Islands',
        flag: '🇹🇨',
        code: '+1649',
        iso: 'TC',
        mask: '(###)###-####'
    },
    {
        name: 'Tuvalu',
        flag: '🇹🇻',
        code: '+688',
        iso: 'TV',
        mask: '#####'
    },
    {
        name: 'Ukraine',
        flag: '🇺🇦',
        code: '+380',
        iso: 'UA',
        mask: '(##)###-##-##'
    },
    {
        name: 'United Arab Emirates',
        flag: '🇦🇪',
        code: '+971',
        iso: 'AE',
        mask: '#-###-####'
    },
    {
        name: 'United Kingdom',
        flag: '🇬🇧',
        code: '+44',
        iso: 'GB',
        mask: '##-####-####'
    },
    {
        name: 'United States',
        flag: '🇺🇸',
        code: '+1',
        iso: 'US',
        mask: '(###)###-####'
    },
    {
        name: 'Uruguay',
        flag: '🇺🇾',
        code: '+598',
        iso: 'UY',
        mask: '#-###-##-##'
    },
    {
        name: 'US Virgin Islands',
        flag: '🇻🇮',
        code: '+1340',
        iso: 'VI',
        mask: '(###)###-####'
    },
    {
        name: 'Uzbekistan',
        flag: '🇺🇿',
        code: '+998',
        iso: 'UZ',
        mask: '##-###-####'
    },
    {
        name: 'Vanuatu',
        flag: '🇻🇺',
        code: '+678',
        iso: 'VU',
        mask: '#####'
    },
    {
        name: 'Vatican City',
        flag: '🇻🇦',
        code: '+379',
        iso: 'VA',
        mask: '##-###-####'
    },
    {
        name: 'Vietnam',
        flag: '🇻🇳',
        code: '+84',
        iso: 'VN',
        mask: '##-####-###'
    },
    {
        name: 'Wallis and Futuna',
        flag: '🇼🇫',
        code: '+681',
        iso: 'WF',
        mask: '##-####'
    }
]; 